<template>
  <div class="copyright-wrap">
    <div class="b">
      <ul class="nav">
        <li v-for="(link,i) in links" :key='i'>
          <a :href="link.link" target="_blank">{{link.name}}</a>
        </li>
      </ul>
      <div class="copyright">
		<p>&copy;木串（仙游）科技有限公司 &nbsp;<a href="http://www.beian.miit.gov.cn/" target = "_blank" >闽ICP备19022031号-1</a> </p> 
       <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35032202000145" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="https://www.mkji.cn/facai/img/gon.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">闽公网安备 35032202000145号</p></a> 
	</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props:{
    links:{
      type:Array,
      default:function(){
        return []
      }
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.copyright-wrap {
  width: 100%;
  background: #fafafa;
  .b {
    position: relative;
    min-width: 100%;
    padding: 30px 0;
    ul {
      display: flex;
      justify-content: center;
      padding: 16px 0;
      li {
        border-right: 1px solid #666;
        &:last-of-type {
          border: none;
        }
        a {
          display: block;
          padding: 0 8px;
          font-size: 12px;
          color: rgba(102, 102, 102, 1);
          text-align: center;
        }
      }
    }
    .copyright {
      margin: 0 auto;
      height: 12px;
      font-size: 12px;
      text-align: center;
      color: rgba(153, 153, 153, 1);
    }
  }
}
</style>